/* eslint-disable default-case */
import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components/macro';

export const Icon = ({
  type,
  buttonType,
  size,
  customLabel,
  materialLabel,
  s4cImageUrl,
  altText,
}) => {
  const Icon = () => {
    switch (type) {
      case 'custom':
        return (
          <CustomIcon
            style={{
              maskImage: `url(${require('../../../img/icons/' +
                customLabel +
                '.svg')})`,
              WebkitMaskImage: `url(${require('../../../img/icons/' +
                customLabel +
                '.svg')})`,
            }}
            type={buttonType}
            size={size}
          />
        );
      case 'material':
        return (
          <CustomIcon
            className="material-icons"
            style={{
              maskImage: `url(${require('../../../img/icons/material/' +
                materialLabel +
                '.svg')})`,
              WebkitMaskImage: `url(${require('../../../img/icons/material/' +
                materialLabel +
                '.svg')})`,
            }}
            type={buttonType}
            size={size}
          />
        );
      case 's4c':
        return <S4CIcon src={s4cImageUrl} alt={altText} size={size} />;
    }
  };
  return <Icon />;
};

Icon.propTypes = {
  type: PropTypes.oneOf(['custom', 'material', 's4c']),
  size: PropTypes.oneOf(['small', 'medium', 'large', 'x-large']),
  customLabel: PropTypes.string,
  materialLabel: PropTypes.string,
  s4cLabel: PropTypes.string,
  altText: PropTypes.string,
};

const CustomIcon = styled.span`
  display: flex;
  mask-size: contain;
  mask-repeat: no-repeat;

  ${({ type }) => {
    switch (type) {
      case 'primary':
        return css`
          background-color: ${(props) => props.theme.color.blackFull};
        `;
      case 'secondary':
      case 'tertiary':
      default:
        return css`
          background-color: ${(props) =>
            props.theme.name === 'light'
              ? props.theme.color.blackFull
              : props.theme.color.whiteFull};
        `;
    }
  }};
  ${({ size }) => {
    switch (size) {
      case 'small':
        return `
          font-size: 20px;
          width: 20px !important;
          height: 20px !important;
        `;
      case 'medium':
        return `
          font-size: 22px;
          width: 22px !important;
          height: 22px !important;
        `;
      case 'large':
        return `
          font-size: 24px;
          width: 24px !important;
          height: 24px !important;
        `;
      case 'x-large':
        return `
          font-size: 32px;
          width: 32px !important;
          height: 32px !important;
        `;
    }
  }};
`;

const S4CIcon = styled.img`
  position: relative;
  overflow: hidden;
  ${({ size }) => {
    switch (size) {
      case 'small':
        return `
          width: 20px;
          height: 20px;
        `;
      case 'medium':
        return `
          width: 22px;
          height: 22px;
        `;
      case 'large':
        return `
          width: 24px;
          height: 24px;
        `;
      case 'x-large':
        return `
          width: 32px;
          height: 32px;
        `;
    }
  }}
  }
`;

Icon.propTypes = {
  disabled: PropTypes.bool,
  avatarLabel: PropTypes.oneOf([
    'girl',
    'gorilla',
    'happy',
    'panda',
    'robot',
    'zombie',
  ]),
  customLabel: PropTypes.oneOf([
    'add_circle_outline',
    'add',
    'alarm',
    'arrow_back',
    'arrow_drop_down',
    'cancel',
    'chat_bubble',
    'check_box_outline_blank',
    'check_box',
    'check_circle_outline',
    'check-orange',
    'check-white',
    'check',
    'chevron_left',
    'chevron_right',
    'circle_add',
    'circle_close',
    'circle_facebook',
    'circle_google',
    'circle_linkedin',
    'circle_pinterest',
    'circle_remove',
    'circle_share',
    'circle_twitter',
    'clic_play_error',
    'clic_play_lock',
    'clic_play',
    'close_white',
    'close',
    'email',
    'error_red',
    'error_white',
    'error',
    'event',
    'expand_less',
    'expand_more',
    'facebook',
    'favorite_outline',
    'favorite',
    'first_page',
    'forum',
    'google_plus',
    'googleplus',
    'home',
    'image',
    'instagram',
    'last_page',
    'layers_white',
    'layers',
    'linked_in',
    'linkedin',
    'list',
    'live_tv',
    'lock_open',
    'lock',
    'menu',
    'navigate_before',
    'navigate_next',
    'person',
    'pinterest',
    'play_arrow',
    'play_circle_outline',
    'remove_circle_outline',
    'search',
    'share',
    'sign',
    'subtitles',
    'swap_horiz',
    'timer',
    'toggle_cross',
    'toggle_tick',
    'tv',
    'twitter',
    'warning',
    'youtube',
  ]),
  materialLabel: PropTypes.oneOf([
    'remove_circle_outline',
    'control_point',
    'check_box',
    'check_box_outline_blank',
    'keyboard',
    'arrow_back_ios',
    'arrow_forward_ios',
    'share',
    'radio_button_checked',
    'search',
    'close',
    'home',
    'replay',
    'bookmark',
    'tv',
    'event',
    'layers',
    'navigate_before',
    'navigate_next',
  ]),
  s4cLabel: PropTypes.oneOf([
    'cyw',
    'avatar',
    'walter',
    'hansh',
    'learners',
    'stwnsh',
  ]),
  size: PropTypes.oneOf(['small', 'medium', 'large', 'x-large']),
  type: PropTypes.oneOf(['custom', 'material', 's4c']),
};

Icon.defaultProps = {
  disabled: false,
  avatarLabel: 'gorilla',
  customLabel: 'alarm',
  materialLabel: 'close',
  s4cLabel: 'cyw',
  type: 'custom',
  size: 'medium',
};
